import * as commonUse from './common';
import * as renderUse from './render';
import * as editorUse from './editor';

export const FEGOUse = {
    ...commonUse,
    ...window.FEGORender ? renderUse : editorUse
};

export default FEGOUse;
